import { ReactComponent as NextImg } from "assets/svgs/next.svg";

import * as S from "./HomeContent.style";

import env from "config/envs";

const HomeContent = () => {
  const handleClickRedirect = (event, url) => {
    event?.preventDefault();

    if (!url) {
      return;
    }

    window.location.href = url;
  };

  return (
    <S.HomeContent>
      <S.HomeInfo>
        <S.Title variant="headline-02" color="primary">
          Conheça a nossa história
        </S.Title>
        <S.CardContainer role="list">
          <S.HomeCard
            as="a"
            href="#"
            role="list-item"
            onClick={(e) => handleClickRedirect(e, "/cnp-assurances")}
          >
            <S.CardImage
              src={`${env.HOST_STATIC_CDN}/AreaAberta/Images/banner_whoweare.webp`}
              width="280px"
              height="194px"
              alt=""
            />
            <S.CardFooter variant="body01-sm" color="primary">
              CNP Assurances <NextImg />
            </S.CardFooter>
          </S.HomeCard>

          <S.HomeCard
            as="a"
            href="#"
            role="list-item"
            onClick={(e) =>
              handleClickRedirect(e, "/cnp-seguros-holding-brasil")
            }
          >
            <S.CardImage
              src={`${env.HOST_STATIC_CDN}/AreaAberta/Images/banner_ourhistory.webp`}
              width="280px"
              height="194px"
              alt=""
            />
            <S.CardFooter variant="body01-sm" color="primary">
              CNP Seguros Holding <NextImg />
            </S.CardFooter>
          </S.HomeCard>

          <S.HomeCard
            as="a"
            href={env.HOST_INSTITUTE}
            target="_blank"
            role="list-item"
          >
            <S.CardImage
              src={`${env.HOST_STATIC_CDN}/AreaAberta/Images/card_institute.webp`}
              width="280px"
              height="194px"
              alt=""
            />
            <S.CardFooter variant="body01-sm" color="primary">
              Instituto CNP Brasil <NextImg />
            </S.CardFooter>
          </S.HomeCard>
        </S.CardContainer>
      </S.HomeInfo>
    </S.HomeContent>
  );
};

export default HomeContent;
